import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { RoleGuard } from '../guards/role-guard.service'

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./tracking-route.container').then((m) => m.TrackingRouteContainerComponent),
    data: { contextPath: ['tracking'] },
    canActivate: [RoleGuard],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrackingRoutingModule {}
